/* eslint-disable */
/* eslint-disable sonarjs/no-duplicate-string */
import { RACCOLOR, makeStyles } from '@rentacenter/racstrap';

export const customerStyles = () => {
    const UseClasses = makeStyles((theme) => ({
        customerCheckbox: {
            color: `${RACCOLOR.DEEP_SKY_BLUE}`,
        },
        customerRaclink: {
            color: `${RACCOLOR.BLUE_CRAYOLA}`,
            textDecoration: 'none',
            fontFamily: 'OpenSans-semibold',
            cursor: 'pointer',
        },
        selectedStyle: {
            color: `${RACCOLOR.BLUE_CRAYOLA}`,
            textDecoration: 'none',
            fontFamily: 'OpenSans-semibold',

        },
        racFixedFooterMargin: {
            marginBottom: '120px',
        },
        mb3: {
            marginBottom: theme.typography.pxToRem(16),
        },
        floatRight: {
            float: 'right',
        },
        ms2: {
            marginLeft: theme.typography.pxToRem(8),
        },
        mt2: {
            marginTop: '0.5rem !important',
        },
        customerToolbar: {
            position: 'fixed',
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 1030,
            backgroundColor: `${RACCOLOR.WHITE}`,
            boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
            paddingLeft: theme.typography.pxToRem(16),
            paddingRight: theme.typography.pxToRem(16),
            paddingTop: theme.typography.pxToRem(16),
            paddingBottom: theme.typography.pxToRem(16),
        },
        fixedBottom: {
            position: 'fixed',
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 1030,
            backgroundColor: `${RACCOLOR.WHITE}`,
            boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
            padding: '1rem',
        },
        spacerMR2: {
            marginRight: theme.typography.pxToRem(8),
        },
        stickyNumber: {
            position: 'sticky',
            left: 50,
            backgroundColor: '#fff',
            zIndex: 19,
            boxShadow: '4px 0px 6px 0px #0E3A931A',
        },
        stickyNumbers: {
            position: 'sticky',
            left: 50,
            backgroundColor: '#fff',
            zIndex: 21,
            boxShadow: '4px 0px 6px 0px #0E3A931A',
        },
        stickyCheckbox: {
            position: 'sticky',
            left: 0,
            backgroundColor: '#fff',
        },
        space: {
            width: '150px',
            whiteSpace: 'nowrap',
            backgroundColor: '#cdd3d8',

        },
        searchBoxStyle: {
            marginTop: '10px',
        },
        filterBoxStyle: {
            marginBottom: '7px',
            marginTop: '-7px',
            marginLeft: '3px'
        },
        filterBoxStyle1: {
            marginTop: '10px',
            marginLeft: '14px'
        },
        GridLoader: {
            textAlign: 'center',
            marginBottom: theme.typography.pxToRem(20),
            fontSize: theme.typography.pxToRem(16),
            color: `${RACCOLOR.RICH_BLACK}`,
            margin: '30px 0px',
        },
        mt9: {
            marginTop: theme.typography.pxToRem(8)
        },
        mR1: {
            marginRight: '10px',
        },

        //CSNew
        parentclass: {
            float: 'left',
            width: '100%',
        },
        flexratio: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        row: {
            display: 'flex',
            width: '100%',
        },
        errorText: {
            color: '#ef0000',
            margin: 0,
            fontSize: '13px',
            fontWeight: 100,
            fontFamily: 'OpenSans-regular',
        },

        //CSNew

        //basicinfo
        mb16: {
            marginBottom: theme.typography.pxToRem(16),
        },
        px2: {
            paddingRight: theme.typography.pxToRem(8),
            paddingLeft: theme.typography.pxToRem(8),
        },
        mb120: {
            marginBottom: "120px",
        },
        card: {
            borderRadius: theme.typography.pxToRem(16),
            boxShadow: "0 1px 4px 0 rgba(0,0,0,.074)",
            width: "100%",
        },
        mtb30: {
            marginTop: "20px",
            marginBottom: "20px",
        },
        w100: {
            width: "100%",
        },
        title: {
            color: "#212529",
            fontFamily: "OpenSans-bold",
            fontSize: "16px",
            marginBottom: "20px",
        },
        titleInfo: {
            color: "#212529",
            fontFamily: "OpenSans-bold",
            fontSize: "16px",
            marginTop: "5px",
        },
        uploadButton: {
            fontFamily: 'OpenSans-bold',
            fontWeight: 200,
            fontSize: '14px',
            color: '#241f1fff',
            marginTop: "15px",
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: '#0056b3',
                color: '#ffff'
            },
        },
        pm: {
            padding: '12px 0px',
        },
        notesLabel: {
            color: "#212529",
        },
        reqField: {
            color: "red",
        },
        btn: {
            marginTop: theme.typography.pxToRem(20),
            marginLeft: theme.typography.pxToRem(30),
        },
        btn1: {
            marginLeft: theme.typography.pxToRem(20),
        },
        //basicinfo


        //footer
        footerRoot: {
            width: '100%',
            marginBottom: '0rem',
            display: 'block',
            position: 'fixed',
            bottom: '0',
            left: '0',
            zIndex: 1100,
        },
        footerCard: {
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '0',
        },
        footerCardBody: {
            flex: '0 0 auto',
            padding: '1rem 1rem',
        },
        footerRightButtonsContainer: {
            display: 'flex',
            flex: 1,
            justifyContent: 'flex-end',
            gap: theme.typography.pxToRem(4),
        },
        footerButton: {
            height: theme.typography.pxToRem(43),
        },
        footerButtonRes: {
            marginTop: theme.typography.pxToRem(30),
            marginLeft: theme.typography.pxToRem(50),
        },
        uploadBtnRes: {
            marginTop: theme.typography.pxToRem(30),
        },
        masterLoader: {
            position: 'fixed',
            backgroundColor: `${RACCOLOR.WASHED_BLACK}`,
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            opacity: 0.6,
            zIndex: 1050,
            textAlign: 'center',
            margin: 0,
        },
        Loader: {
            display: 'block',
            position: 'fixed',
            zIndex: 1051,
            top: '50%',
            right: '50%',
        },
        //footer

        //assignment info

        mb15: {
            marginTop: theme.typography.pxToRem(16),
            marginBottom: theme.typography.pxToRem(16),
            marginLeft: theme.typography.pxToRem(40)
        },
        escaltedinfo: {
            marginTop: theme.typography.pxToRem(16),

        },

        modalWrapper: {
            width: '100%',
            padding: theme.typography.pxToRem(8),
        },

        formGrid: {
            marginTop: theme.typography.pxToRem(3),
        },

        submitBtn: {
            height: theme.typography.pxToRem(46),
            borderRadius: theme.typography.pxToRem(8),
            fontWeight: 600,
        },

        dialogContent: {
            textAlign: 'left',
            padding: theme.typography.pxToRem(16),
            minHeight: theme.typography.pxToRem(180),
        },

        dialogRoot: {
            '& .MuiDialogContent-root': {
                padding: theme.typography.pxToRem(16),
            },
            '& .MuiDialog-paperWidthSm': {
                maxWidth: theme.typography.pxToRem(400),
                maxHeight: theme.typography.pxToRem(460),
            },
            '& .MuiTypography-h4': {
                fontSize: '20px !important',
                fontWeight: 700,
            },
            '& .MuiDialogTitle-root': {
                padding: theme.typography.pxToRem(16),
            },
        },

        //activity
        activityDivider: {
            borderTop: `1px solid ${theme.palette.divider}`,
            marginTop: theme.typography.pxToRem(8),
            paddingTop: theme.typography.pxToRem(12),
        },
        leftTime: {
            fontFamily: 'OpenSans-semibold',
            lineHeight: 1.6,
        },
        leftMeta: {
            color: theme.palette.text.secondary,
            lineHeight: 1.6,
            marginTop: theme.typography.pxToRem(6),
        },
        leftMetaDense: {
            color: theme.palette.text.secondary,
            lineHeight: 1.6,
            marginTop: theme.typography.pxToRem(4),
        },
        leftStatus: {
            fontFamily: 'OpenSans-semibold',
            lineHeight: 1.6,
            marginTop: theme.typography.pxToRem(10),
        },
        rightNoteWrap: {
            maxWidth: 'min(72ch, 100%)',
            width: '100%',
            lineHeight: 1.65,
        },
        rightNoteText: {
            lineHeight: 1.65,
            textAlignLast: 'left',
            wordBreak: 'normal',
            overflowWrap: 'anywhere',
        },
        rightNoteLabel: {
            fontFamily: 'OpenSans-bold',
        },
        noteLabel: {
            fontFamily: 'OpenSans-semibold',
        },
        rightNoteContent: {
            whiteSpace: 'pre-wrap',
            color: RACCOLOR.DARK_GREY,
            fontSize: theme.typography.pxToRem(14),
            fontFamily: 'OpenSans-regular',
        },
        rightNoNoteWrap: {
            lineHeight: 1.6,
        },
        rightNoNoteResolved: {
            color: theme.palette.text.secondary,
            lineHeight: 1.6,
            marginBottom: theme.typography.pxToRem(4),
        },
        rightNoNoteAssigned: {
            color: theme.palette.text.secondary,
            lineHeight: 1.6,
        },
    }));
    // eslint-disable-next-line sonarjs/prefer-immediate-return
    const classes = UseClasses();
    return classes;
};
